import React, { useState, useEffect } from 'react';
import './StaggeredTestimonials.scss';

const testimonials = [
  {
    quote: "Nice experience with my Ahmedabad to Delhi cab. Smooth booking and a comfortable journey all the way.",
    author: "Hitesh Mudhra",
    role: "Ahmedabad to Delhi, one way"
  },
  {
    quote: "Booked a Delhi to Jaipur cab for my parents. Driver arrived 10 minutes early, drove carefully on NH48, and the fare matched the quote exactly. No surprises at drop-off.",
    author: "Rajesh Khandelwal",
    role: "Delhi to Jaipur, one way"
  },
  {
    quote: "Very clean car and professional behaviour. I travel alone from Surat to Ahmedabad for work and the live tracking gives my family peace of mind.",
    author: "Krupa Patel",
    role: "Surat to Ahmedabad, monthly"
  },
  {
    quote: "Our Lucknow to Varanasi trip was effortless. No hidden tolls or parking charges - everything was shown before I confirmed the booking.",
    author: "Awadhesh Srivastava",
    role: "Family traveller"
  },
  {
    quote: "Best airport transfer experience in Ahmedabad. The driver was waiting before my flight landed and helped with all three bags.",
    author: "Meenakshi Iyer",
    role: "Frequent business traveller"
  },
  {
    quote: "Transparent per-kilometre pricing is the best part. What I saw on the website for Pune to Nashik is exactly what I paid. No haggling, no cash demands.",
    author: "Sandeep Deshmukh",
    role: "Pune to Nashik, weekend trips"
  },
  {
    quote: "Took a one-way cab from Chennai to Tirupati with my in-laws. Polite driver, sensible halts, and the car was spotless. Booking took two minutes.",
    author: "Lakshmi Venkatesan",
    role: "Pilgrimage traveller"
  },
  {
    quote: "I book corporate rides for our Gandhinagar office every week. GST invoices arrive on time and the coordination has been flawless for six months.",
    author: "Harshad Trivedi",
    role: "Admin manager, corporate account"
  },
  {
    quote: "Jaipur to Udaipur through the hills - the driver knew every stretch of the route and we reached ahead of time. Genuinely reliable outstation service.",
    author: "Devendra Singh Shekhawat",
    role: "Jaipur to Udaipur, round trip"
  }
];

// Deterministic brand colour per author for the initials avatar.
const AVATAR_COLORS = ["#21A5A0", "#E05A49", "#0B1F3A", "#2DB8B3"];
const initialsOf = (name) =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="testimonial-section" aria-label="Customer testimonials">
      <div className="testimonial-section__container">
        <header className="testimonial-section__header">
          <span className="testimonial-section__subtitle">Rider Stories</span>
          <h2 className="testimonial-section__title">What Our Riders Say</h2>
          <p className="testimonial-section__description">
            Real stories from our 10,000+ happy travelers who trust Pulpit Cabs for safe, reliable, and comfortable journeys across India.
          </p>
        </header>

        <div className="testimonial-section__content">
          <blockquote className="testimonial-section__quote">
            <p className="testimonial-section__text">
              {currentTestimonial.quote}
            </p>
            <footer className="testimonial-section__footer">
              <div className="testimonial-section__author-info">
                <span
                  className="testimonial-section__avatar testimonial-section__avatar--initials"
                  style={{ backgroundColor: AVATAR_COLORS[currentIndex % AVATAR_COLORS.length] }}
                  aria-hidden="true"
                >
                  {initialsOf(currentTestimonial.author)}
                </span>
                <div>
                  <cite className="testimonial-section__author">
                    {currentTestimonial.author}
                  </cite>
                  <div className="testimonial-section__role">
                    {currentTestimonial.role}
                  </div>
                </div>
              </div>
            </footer>
          </blockquote>

          <nav className="testimonial-section__navigation" aria-label="Testimonials navigation">
            <button
              onClick={prevTestimonial}
              className="testimonial-section__btn testimonial-section__btn--prev"
              aria-label="Previous testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className="testimonial-section__btn testimonial-section__btn--next"
              aria-label="Next testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </nav>

          <div className="testimonial-section__indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`testimonial-section__indicator ${index === currentIndex ? 'testimonial-section__indicator--active' : ''}`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
